/*
  Voor en na.

  Het schuifveld in de opmaak is de echte bediening. Dit script doet twee
  dingen: het zet de waarde om in de knip-positie, en het laat je op de foto
  zelf slepen in plaats van alleen op het schuifje.

  Zonder JavaScript blijft de foto staan met de schuif op het midden, en werkt
  het schuifveld gewoon met het toetsenbord.
*/
(function () {
  function koppel(paar) {
    var schuif = paar.querySelector('[data-lez-voorna-schuif]');
    if (!schuif) return;

    function teken() {
      paar.style.setProperty('--lez-voorna-x', schuif.value + '%');
    }

    schuif.addEventListener('input', teken);
    teken();

    /* Slepen op de foto zelf. Het schuifveld ligt er al overheen, maar dat
       verspringt in sommige browsers naar de klikpositie in plaats van mee te
       lopen met de vinger. Daarom rekenen we de positie zelf uit. */
    var bezig = false;

    function positieUit(x) {
      var r = paar.getBoundingClientRect();
      if (!r.width) return;
      var pct = ((x - r.left) / r.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      schuif.value = String(Math.round(pct));
      teken();
    }

    paar.addEventListener('pointerdown', function (e) {
      bezig = true;
      paar.setPointerCapture(e.pointerId);
      positieUit(e.clientX);
    });

    paar.addEventListener('pointermove', function (e) {
      if (!bezig) return;
      positieUit(e.clientX);
    });

    function stop(e) {
      if (!bezig) return;
      bezig = false;
      try {
        paar.releasePointerCapture(e.pointerId);
      } catch (fout) {
        /* De aanwijzer was al losgelaten; niets aan de hand. */
      }
    }

    paar.addEventListener('pointerup', stop);
    paar.addEventListener('pointercancel', stop);
  }

  function init() {
    document.querySelectorAll('[data-lez-voorna]').forEach(function (paar) {
      if (paar.dataset.lezKlaar) return;
      paar.dataset.lezKlaar = '1';
      koppel(paar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* De thema-editor bouwt secties opnieuw op. */
  document.addEventListener('shopify:section:load', init);
})();
